import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Container } from 'styles/container.styles';
import { breakpoints } from 'styles/breakpoints.styles';
import { SubPageBanner, SubPageNav, SubPageTop } from 'styles/subPage.styles';
import noticeBanner from 'assets/img/notice/banner.png';
import noticeBannerMobile from 'assets/img/notice/banner_mobile.png';
import { NavLink } from 'react-router-dom';
import ContactBanner from 'components/ContactBanner';
import AdSense from 'components/AdSense';
import { ADSENSE_SLOTS } from 'config/adsense.config';
import { FAQ_ITEMS } from 'data/faq';
import { SITE_URL } from 'config/seo.config';
import { FaqContainer } from 'pages/Guide/styles';

const Faq = () => {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <>
      <Helmet>
        <title>자주 묻는 질문(FAQ) - 마트통포스</title>
        <meta
          name='description'
          content='마트통포스 POS·키오스크·ESL·CRM 도입에 대해 소상공인 사장님이 자주 묻는 질문과 답변을 모았습니다. 비용, 데이터 이전, 교육, 지원까지 안내합니다.'
        />
        <link rel='canonical' href={`${SITE_URL}/faq`} />
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: FAQ_ITEMS.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer.join(' '),
              },
            })),
          })}
        </script>
      </Helmet>

      <SubPageTop>
        <SubPageBanner>
          <picture>
            <source media={breakpoints.mobile} srcSet={noticeBannerMobile} />
            <img src={noticeBanner} alt='자주 묻는 질문' />
          </picture>

          <div className='banner__content'>
            <small>Support</small>
            <p>자주 묻는 질문</p>
          </div>
        </SubPageBanner>

        <SubPageNav>
          <ul>
            <li>
              <NavLink to='/guide'>전체 가이드</NavLink>
            </li>
            <li>
              <NavLink to='/faq'>자주 묻는 질문</NavLink>
            </li>
          </ul>
        </SubPageNav>
      </SubPageTop>

      <Container>
        <FaqContainer>
          <div className='faq-intro'>
            <h1>마트통포스 자주 묻는 질문</h1>
            <p>
              POS 도입, 재고·가격 관리, 키오스크·무인매장, CRM 마케팅과 관련해
              상담 중 가장 많이 받는 질문을 정리했습니다. 답변으로 부족하면
              고객문의로 매장 상황을 남겨 주세요.
            </p>
            <p>
              더 자세한 운영 팁은 <Link to='/guide'>매장 운영 가이드</Link>
              에서도 확인할 수 있습니다.
            </p>
          </div>

          <div className='faq-list'>
            {FAQ_ITEMS.map((item, index) => {
              const isOpen = openIndex === index;

              return (
                <div className='faq-item' key={item.question}>
                  <button
                    type='button'
                    className='faq-item__question'
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  >
                    <span>{item.question}</span>
                    <i
                      className={`far ${isOpen ? 'fa-minus' : 'fa-plus'}`}
                      aria-hidden
                    />
                  </button>
                  {isOpen && (
                    <div className='faq-item__answer'>
                      {item.answer.map((paragraph) => (
                        <p key={paragraph.slice(0, 24)}>{paragraph}</p>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <AdSense slot={ADSENSE_SLOTS.inArticle} />

          <div className='faq-contact'>
            <p>
              답변에서 해결되지 않았다면 <Link to='/contact'>고객문의</Link>를
              이용해 주세요.
            </p>
            <p>
              전화 {process.env.REACT_APP_COMPANY_TEL || '02-6952-7652'} ·
              이메일{' '}
              {process.env.REACT_APP_COMPANY_EMAIL || 'kps@runninglab.co.kr'}
            </p>
          </div>
        </FaqContainer>
      </Container>

      <ContactBanner type='green' />
    </>
  );
};

export default Faq;
